import {createAction as createActionCreator} from 'redux-actions';
import {Map, fromJS} from 'immutable';

import * as constants from '../../constants';

const NAMESPACE = `${constants.NAMESPACE}/child`;

// Actions
const SAVE = `${NAMESPACE}/SAVE`;
const RESET = `${NAMESPACE}/RESET`;

// Reducer
export default function reducer(state = Map(), action = {}) {
  if (!Map.isMap(state)) {
    console.warn(`state is no Map but ${typeof state} -> converting to Map NOW.`);
    state = fromJS(state);
  }

  switch (action.type) {
    case SAVE:
      return setChildData(state, action.payload);
    case RESET:
      return Map();
    default:
      return state;
  }
}

function setChildData(state, data) {
  data.tshirtGroesseText = getTextForTshirtGroesse(data.tshirtGroesse);
  return state.set(`${data.kindNr}`, Map(data));
}

function getTextForTshirtGroesse(tshirtGroesse) {
  switch (tshirtGroesse) {
    case 1:
      return "86/92";
    case 2:
      return "98/104";
    case 3:
      return "110/116";
    case 4:
      return "122/128";
    case 5:
      return "134/140";
    case 6:
      return "146/152";
    case 7:
      return "S";
    case 8:
      return "M";
    case 9:
      return "L";
    case 10:
      return "XL";
    case 11:
      return "XXL";
    default:
      return "unbekannt";
  }
}

export function getChildrenDataAsPOJO(state) {
  return state.toJS();
}

const save = createActionCreator(SAVE);
export function saveChildData(kindNr, vorname, nachname, geburtsdatum, tshirtGroesse, tetanusImpfungVorhanden, geschlecht, allergien, sonstiges) {
  return save({
    kindNr,
    vorname,
    nachname,
    geburtsdatum,
    tshirtGroesse,
    tetanusImpfungVorhanden,
    geschlecht,
    allergien,
    sonstiges,
  });
}

const resetActionCreator = createActionCreator(RESET);
export function reset() {
  return resetActionCreator();
}

export function getValues(state, kindNr) {
  let values = null;

  if (Map.isMap(state) && state.get(`${kindNr}`) !== undefined) {
    let child = state.get(`${kindNr}`);
    values = {
      vorname: child.get('vorname'),
      nachname: child.get('nachname'),
      geburtsdatum: child.get('geburtsdatum'),
      tshirtGroesse: child.get('tshirtGroesse'),
      tetanusImpfungVorhanden: child.get('tetanusImpfungVorhanden'),
      geschlecht: child.get('geschlecht'),
      allergien: child.get('allergien'),
      sonstiges: child.get('sonstiges'),
    }
  }

  return values;
}



// WEBPACK FOOTER //
// ./src/components/child/child.js